import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAnalytics = () => {
  const location = useLocation();
  const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

  useEffect(() => {
    // Only load if GA_MEASUREMENT_ID is configured
    if (!GA_MEASUREMENT_ID) {
      console.log('Google Analytics not configured. Add REACT_APP_GA_MEASUREMENT_ID to .env');
      return;
    }

    // Initialize GA4
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
      send_page_view: true
    });
  }, [GA_MEASUREMENT_ID]);

  // Track page views on route change
  useEffect(() => {
    if (window.gtag && GA_MEASUREMENT_ID) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location.pathname, location.search, GA_MEASUREMENT_ID]);

  return null;
};

export default GoogleAnalytics;

// Helper functions for custom event tracking
export const trackEvent = (eventName, parameters = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

export const trackFormSubmission = (formName) => {
  trackEvent('form_submission', {
    form_name: formName
  });
};

export const trackButtonClick = (buttonName, location) => {
  trackEvent('button_click', {
    button_name: buttonName,
    button_location: location
  });
};

export const trackServiceExpand = (serviceName) => {
  trackEvent('service_expand', {
    service_name: serviceName
  });
};
